// This file is generated by a script. Do not edit this file directly.
import React, { createContext, useContext } from 'react';
import { ChoiceGroupDirection, ChoiceGroupColumns, ChoiceGroupLayout } from "../../common/ChoiceGroupLayout/ChoiceGroupLayout";
var RadioGroupContext = /*#__PURE__*/createContext(null);
export var useRadioGroup = function useRadioGroup() {
  var context = useContext(RadioGroupContext);
  return context;
};
export var RadioGroup = function RadioGroup(_ref) {
  var label = _ref.label,
    description = _ref.description,
    error = _ref.error,
    helperText = _ref.helperText,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? ChoiceGroupDirection.VERTICAL : _ref$direction,
    _ref$layout = _ref.layout,
    layout = _ref$layout === void 0 ? ChoiceGroupColumns.SingleCol : _ref$layout,
    value = _ref.value,
    onChange = _ref.onChange,
    children = _ref.children,
    className = _ref.className,
    tooltipProps = _ref.tooltipProps;
  return /*#__PURE__*/React.createElement(RadioGroupContext.Provider, {
    value: {
      value: value,
      onChange: onChange
    }
  }, /*#__PURE__*/React.createElement(ChoiceGroupLayout, {
    label: label,
    description: description,
    error: error,
    helperText: helperText,
    tooltipProps: tooltipProps,
    className: className,
    direction: direction,
    layout: layout
  }, children));
};
